import { milestoneReportsModule } from "@/modules/charts-dashboard/services/store/milestone/milestone.module";
import { EMilestoneReportsState } from "@/modules/charts-dashboard/services/store/milestone/milestone.interface";

export const modules = {
  [EMilestoneReportsState.NAMESPACE]: milestoneReportsModule,
};
